<td>{{ 'BILLING.STATUSES.' + status | translate }}</td>
<td>{{ quantity }}</td>
@if (!editMode) {
<td class="price-cell">
  <span class="price-label">{{ price | platformCurrency }}/mo</span>
  @if (isEditable) {
  <mat-icon class="material-icons-outlined" (click)="editMode = true">edit</mat-icon>
  }
</td>
} @else {
<td class="price-cell">
  <mat-form-field>
    <div class="input-prepend">
      <span>{{ clientCurrencySymbol }}</span>
      <input matInput type="number" min="0" [(ngModel)]="price" />
    </div>
    <mat-error></mat-error>
  </mat-form-field>
  <lin-form-submit-button [isLoading]="isLoading" (click)="savePrice()">{{ 'BUTTONS.SAVE' | translate }}</lin-form-submit-button>
</td>
}
<td>{{ quantity * price | platformCurrency }}</td>
